import DeliveryType from "@/module/main/dto/DeliveryTypeEnum";
import IOperatingLeaseOrder from "@/module/main/dto/IOperatingLeaseOrder";
import IOperatingLeaseItem from "@/module/main/dto/IOperatingLeaseItem";

export default class OperatingLeaseOrder implements IOperatingLeaseOrder
{
    constructor(
        public deliveryType: DeliveryType = DeliveryType.ONLINE,
        public items: IOperatingLeaseItem[],
        public reservationDate: string,
    )
    {
    }
}
